import { fetchGet } from "../api/fetch";
import {
  
  DYNAMIC_THEME_INFO
  
} from "../constants/actionTypes";


export const fetchDynamicInfo = () => {
  return async (dispatch) => {
    try {
      const response = await fetchGet(
        "theme/info",
        "dynamic"
      );
     
      dispatch({
        type: DYNAMIC_THEME_INFO,
        dynamicThemeInfo: response
      });
    } catch (e) {
      console.log(e);
    }
  };
};